module.exports = __webpack_public_path__ + "img/banner.d9cd8196.png";